// index.js
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import "bootstrap/dist/css/bootstrap.css";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import "./index.scss";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");

const Root = () => {
  return (
    <BrowserRouter basename={baseUrl}>
      <App />
    </BrowserRouter>
  );
};

const root = ReactDOM.createRoot(rootElement);
root.render(<Root />);

registerServiceWorker();
